import { FC } from 'react';

import { Tag } from 'antd';
import cn from 'classnames';

import { FormattedOption } from 'types/dictionaries';

import { FALLBACK_VALUE } from 'constants/uiSettings';

import styles from './Tags.module.scss';

interface TagsProps {
  dictionary: FormattedOption[];
  values?: string[] | null;
  isTextMode?: boolean;
  className?: string;
}

const Tags: FC<TagsProps> = ({ dictionary, values, isTextMode, className }) => {
  const uniqueValues = values ? Array.from(new Set(values)) : [];

  const labels = uniqueValues.map((value) => {
    const match = dictionary.find((item) => item.value === value);
    return match
      ? { label: match.label, title: match.parentKey || undefined }
      : { label: value, title: undefined };
  });

  if (isTextMode) {
    return labels?.length ? (
      <div className={cn(styles.tagContainer, [className])}>
        {labels.map(({ label }) => label).join(', ')}
      </div>
    ) : (
      FALLBACK_VALUE
    );
  }

  return labels.length ? (
    <div className={cn(styles.tagContainer, [className])}>
      {labels.map(({ label, title }, index) => (
        <Tag bordered={false} key={uniqueValues[index]} title={title}>
          {label}
        </Tag>
      ))}
    </div>
  ) : (
    FALLBACK_VALUE
  );
};

export default Tags;
